import React from "react";
import { Button, Tabs } from "antd";
import { observer } from "mobx-react";

import Customizer from "../Customizer.js";
import { Face, SavableFace } from "../../models/Book";
import { getSnapshot } from "mobx-state-tree";
import {
  imgsBoyNakagawa,
  imgsGirlNakagawa,
  imgsPapaNakagawa,
  imgsMamaNakagawa,
  imgsBoyMomoro,
  imgsGirlMomoro,
  imgsPapaMomoro,
  imgsMamaMomoro
} from "./FaceSelectionImage";
import { productTypeMap } from "../../utils/";

const TabPane = Tabs.TabPane;


class FaceSelection extends React.Component {
  constructor(props) {
    super();
    this.isMoleTopSurface = false; // ホクロを一番上のレイヤーにするか
    this.state = {
      boy: SavableFace.create({
        layer1: props.book.parentToChild.boyFace.layer1 !== '' ? props.book.parentToChild.boyFace.layer1 : (props.artistName === "nakagawa" ? '01_face' : '01_face'),
        layer2: props.book.parentToChild.boyFace.layer2 !== '' ? props.book.parentToChild.boyFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '00_cheek'),
        layer3: props.book.parentToChild.boyFace.layer3 !== '' ? props.book.parentToChild.boyFace.layer3 : (props.artistName === "nakagawa" ? '00_cheek' : '00_mole'),
        layer4: props.book.parentToChild.boyFace.layer4 !== '' ? props.book.parentToChild.boyFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '00_glasses'),
        layer5: props.book.parentToChild.boyFace.layer5 !== '' ? props.book.parentToChild.boyFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      girl: SavableFace.create({
        layer1: props.book.parentToChild.girlFace.layer1 !== '' ? props.book.parentToChild.girlFace.layer1 : (props.artistName === "nakagawa" ? '01_face' : '01_face'),
        layer2: props.book.parentToChild.girlFace.layer2 !== '' ? props.book.parentToChild.girlFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '00_cheek'),
        layer3: props.book.parentToChild.girlFace.layer3 !== '' ? props.book.parentToChild.girlFace.layer3 : (props.artistName === "nakagawa" ? '00_cheek' : '00_mole'),
        layer4: props.book.parentToChild.girlFace.layer4 !== '' ? props.book.parentToChild.girlFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '00_glasses'),
        layer5: props.book.parentToChild.girlFace.layer5 !== '' ? props.book.parentToChild.girlFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      papa: SavableFace.create({
        layer1: props.book.parentToChild.papaFace.layer1 !== '' ? props.book.parentToChild.papaFace.layer1 : (props.artistName === "nakagawa" ? '01_face' : '01_face'),
        layer2: props.book.parentToChild.papaFace.layer2 !== '' ? props.book.parentToChild.papaFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '00_mole'),
        layer3: props.book.parentToChild.papaFace.layer3 !== '' ? props.book.parentToChild.papaFace.layer3 : (props.artistName === "nakagawa" ? '00_cheek' : '00_cheek'),
        layer4: props.book.parentToChild.papaFace.layer4 !== '' ? props.book.parentToChild.papaFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '00_glasses'),
        layer5: props.book.parentToChild.papaFace.layer5 !== '' ? props.book.parentToChild.papaFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
      mama: SavableFace.create({
        layer1: props.book.parentToChild.mamaFace.layer1 !== '' ? props.book.parentToChild.mamaFace.layer1 : (props.artistName === "nakagawa" ? '01_face' : '01_face'),
        layer2: props.book.parentToChild.mamaFace.layer2 !== '' ? props.book.parentToChild.mamaFace.layer2 : (props.artistName === "nakagawa" ? '00_mole' : '00_cheek'),
        layer3: props.book.parentToChild.mamaFace.layer3 !== '' ? props.book.parentToChild.mamaFace.layer3 : (props.artistName === "nakagawa" ? '00_cheek' : '00_mole'),
        layer4: props.book.parentToChild.mamaFace.layer4 !== '' ? props.book.parentToChild.mamaFace.layer4 : (props.artistName === "nakagawa" ? '00_glasses' : '00_glasses'),
        layer5: props.book.parentToChild.mamaFace.layer5 !== '' ? props.book.parentToChild.mamaFace.layer5 : (props.artistName === "nakagawa" ? '00_hair' : '00_hair'),
        saved: Face.create({})
      }),
    };
  }

  save = () => {
    this.props.book.parentToChild.boyFace.changeAll(getSnapshot(this.state.boy));
    this.props.book.parentToChild.girlFace.changeAll(getSnapshot(this.state.girl));
    this.props.book.parentToChild.papaFace.changeAll(getSnapshot(this.state.papa));
    this.props.book.parentToChild.mamaFace.changeAll(getSnapshot(this.state.mama));

    this.state.boy.save();
    this.state.girl.save();
    this.state.papa.save();
    this.state.mama.save();

    this.props.order.saveFaces(); // facesSavedのフラグ更新
    this.props.order.nextStep();
  }

  render() {
    const book = this.props.book;
    const productType = productTypeMap[book.productType];
    const { parentToChild } = this.props.book;
    const childrenSex = parentToChild.childrenSex;

    let imgsBoy = [];
    let imgsGirl = [];
    let imgsCreator = [];
    let imgsPartner = [];

    let creatorFace = null;
    let partnerFace = null;

    this.isMoleTopSurface = productType === "parent_to_child" && this.props.artistName === "momoro";

    if (this.props.artistName === "momoro") {
      imgsBoy = imgsBoyMomoro;
      imgsGirl = imgsGirlMomoro;
      imgsCreator = imgsMamaMomoro;
      imgsPartner = imgsPapaMomoro;

      creatorFace = this.state.mama;
      partnerFace = this.state.papa;
    } else if (this.props.artistName === "nakagawa") {
      imgsBoy = imgsBoyNakagawa;
      imgsGirl = imgsGirlNakagawa;
      imgsCreator = imgsPapaNakagawa;
      imgsPartner = imgsMamaNakagawa;

      creatorFace = this.state.papa;
      partnerFace = this.state.mama;
    }

    const state = this.state;

    return (
      <div className="hair-selection">
        <div className="step pd-15">
          <div className="step-title">{"STEP 1：贈るお子様の顔"}</div>
          <div className="step-txt">
            {"まずはプレゼントするお子さまの顔をつくりましょう。"}
            <br />
            {"（左右の矢印をタップすると各パーツが切り替わります）"}
          </div>
        </div>
        { childrenSex === 'male' &&
          <Customizer imgs={imgsBoy} face={this.state.boy} isMoleTopSurface={this.isMoleTopSurface} />
        }
        { childrenSex === 'female' &&
          <Customizer imgs={imgsGirl} face={this.state.girl} isMoleTopSurface={this.isMoleTopSurface} />
        }
        <div className="step step-2 pd-15">
          <div className="step-title">{"STEP 2：あなたの顔"}</div>
          <div className="step-txt">
            {"次に贈り主であるあなたの顔をつくりましょう。"}
            <br />
            {"（左右の矢印をタップすると各パーツが切り替わります）"}
          </div>
        </div>
        <Customizer imgs={imgsCreator} face={creatorFace} isMoleTopSurface={this.isMoleTopSurface} />
        { (productType === "parent_to_child" && !(parentToChild.isSingle === "1")) &&
          <div>
            <div className="step step-2 pd-15">
              <div className="step-title">{"STEP 3：配偶者の顔"}</div>
              <div className="step-txt">
                {"最後にあなたの配偶者の顔をつくりましょう。"}
                <br />
                {"（左右の矢印をタップすると各パーツが切り替わります）"}
              </div>
            </div>
            <Customizer imgs={imgsPartner} face={partnerFace} />
          </div>
        }
        <div style={{ padding: "0px 16px" }}>
          <div className="btn-wrap">
            <button onClick={this.save} className="btn product-btn">
              {"保存して次へ"}
              <img
                src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                className="btn-arrow"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(FaceSelection);



// WEBPACK FOOTER //
// ./src/components/steps/FaceSelectionParentToChild.js